import { Outlet } from "react-router-dom";

const WorksLayout = () => {
    return <Outlet />;
};

export default WorksLayout;
